import * as React from 'react';

import { cn } from '../../../lib/stylingUtils';

export const Widget = React.forwardRef(
  (
    { className, ...props }: React.HTMLProps<HTMLDivElement>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => (
    <div
      ref={ref}
      {...props}
      className={cn(
        '@Widget',
        'rounded-lg border border-neutral/10 bg-white',
        'overflow-clip shadow-neutral/10',
        className,
      )}
    />
  ),
);
